// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__a8WrL","footer":"ChangeClinic_footer__3UMWw"};